import Vue from 'vue'

const COMMENT = {
	LIST: filter => {
		return Vue.$api.get('/comments', { params: { filter: filter } })
	},
	BY_ID: id => {
		return Vue.$api.get('/comments/' + id)
	},

	ANALYSIS: comment => {
		return Vue.$api.post('/analyze/sentiment', comment)
	},
}

export default COMMENT
